import { useEffect } from 'react';

import { useAppDispatch } from '@/store';
import { setHeaderConfig } from '@/store/app.slice';

import ErrorTemplate from './error-template';

/** Роут-заглушка 404 (path: '*'). Без зависимости от меню — показывается всегда. */
const NotFound: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderConfig({ helmetTitle: '404' }));
    return () => {
      dispatch(setHeaderConfig({}));
    };
  }, [dispatch]);

  return <ErrorTemplate type="notFound" />;
};

export default NotFound;
